var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"outline":"","color":"grey"},on:{"click":_vm.getShopProfile}},[_c('v-icon',[_vm._v("fa fa-print")]),_vm._v("\n     "+_vm._s(_vm.$t('Print Covers'))+"\n  ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3c1570","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/ecommerce/PrintAllCoversBearhouse.vue
// module id = null
// module chunks = 